<template>
  <!-- ========== WARUM VILUU: Perlen am Faden ========== -->
  <section class="k-sec alt reveal" id="warum">
    <div class="k-head">
      <span class="k-eyebrow">Warum Viluu</span>
      <h2>Entspannt bleiben. <span class="grad">Alles andere</span> übernehmen wir.</h2>
      <p>Drei Versprechen, die du jederzeit nachprüfen kannst.</p>
    </div>

    <div class="kw" data-kw>
      <!-- Der Faden: Echo der Signatur-Welle, nur >=821px sichtbar.
           Flache Tangenten an x=158/500/842 — dort "liegen" die Perlen auf. -->
      <svg class="kw-thread" viewBox="0 0 1000 130" preserveAspectRatio="none" aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id="kwg" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="1000" y2="130">
            <stop offset="0" stop-color="#F17C08" />
            <stop offset="1" stop-color="#C63E7C" />
          </linearGradient>
        </defs>
        <path class="kw-line" d="M -40 34 C 40 30, 96 28, 158 28 C 320 28, 350 76, 500 76 C 645 76, 700 48, 842 48 C 905 48, 980 52, 1040 56" fill="none" stroke="url(#kwg)" stroke-width="2" stroke-linecap="round" vector-effect="non-scaling-stroke" opacity=".35" />
      </svg>

      <ul class="kw-list">
        <li class="kw-item">
          <span class="kw-pearl kw-p1" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><use href="#viluu-heart" /></svg></span>
          <h3>Kostenlos starten</h3>
          <p>Registrierung und Profil kosten nichts. Kein Abo, keine versteckten Haken — du behältst jederzeit die volle Kontrolle.</p>
          <span class="kw-fact">Registrierung 0&nbsp;€ · kein Abo</span>
        </li>
        <li class="kw-item">
          <span class="kw-pearl kw-p2" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z" /><path d="M9 12l2 2 4-4" /></svg></span>
          <h3>Betreute Community</h3>
          <p>Profile werden geprüft, unsere Moderation ist erreichbar. Blockieren oder melden geht mit einem Tipp.</p>
          <span class="kw-fact">Melden mit einem Tipp</span>
        </li>
        <li class="kw-item">
          <span class="kw-pearl kw-p3" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="10" rx="2.5" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></svg></span>
          <h3>Deine Daten, deine Regeln</h3>
          <p>Deutscher Anbieter, DSGVO-konform. Deine Daten gehören dir — dein Profil löschst du jederzeit selbst.</p>
          <span class="kw-fact">Löschen — jederzeit</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'KennenlernenWarumSection',
};
</script>
